import { format } from 'date-fns';
import { shiftTypeNames } from '@/constants/schedule.constants';
import { CCAssignmentCandidateShift } from '@/api/apis/resources';

type CCShiftCellProps = {
  ccShift: CCAssignmentCandidateShift | null;
  position: 'start' | 'end';
};

export const CCShiftCell = ({ ccShift, position }: CCShiftCellProps) => {
  if (!ccShift) return null;

  const { from, to, shiftType, isManager } = ccShift;
  const date = position === 'start' ? from : to;
  const dateFormatted = format(date, 'MM/dd/yyyy');

  return (
    <div className="flex flex-col">
      <span>
        {shiftTypeNames[shiftType]}
        {isManager ? ' (Duty)' : ''}
      </span>
      <span>{dateFormatted}</span>
    </div>
  );
};
